module.exports = __webpack_public_path__ + "static/img/liao.c84320b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/liao.png
// module id = 88
// module chunks = 1